// @ts-ignore
import debounce from 'lodash/debounce';
import StateListenerRegistry from '../../../react/features/base/redux/StateListenerRegistry';
const _onUserSelectedDeviceChanged = debounce((_, store) => {
    const state = store.getState();
    // @ts-ignore
    const { isXbees } = state['features/base/config'];
    if (!isXbees) {
        return;
    }
    const { userSelectedMicDeviceId, userSelectedAudioOutputDeviceId, userSelectedCameraDeviceId } = store.getState()['features/base/settings'];
    // @ts-ignore
    APP.xBeesEvents.userSelectedDeviceChanged({
        userSelectedMicDeviceId,
        userSelectedAudioOutputDeviceId,
        userSelectedCameraDeviceId
    });
}, 1000);
/**
 * Waiting for the loading of the conference and automatically starting transcription for external meetings
 */
StateListenerRegistry.register(state => state['features/base/settings'].userSelectedMicDeviceId, 
/* listener */ _onUserSelectedDeviceChanged);
StateListenerRegistry.register(state => state['features/base/settings'].userSelectedAudioOutputDeviceId, 
/* listener */ _onUserSelectedDeviceChanged);
StateListenerRegistry.register(state => state['features/base/settings'].userSelectedCameraDeviceId, 
/* listener */ _onUserSelectedDeviceChanged);
